"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProviderKeyService = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class ProviderKeyService {
  constructor(providerKeyFactories) {
    _defineProperty(this, "_providerKeyFactories", void 0);

    this._providerKeyFactories = providerKeyFactories;
  }

  getKeyByEncryptionKey(key) {
    return this.getKeyByKeyId(key.key, key.prov, key.alg);
  }

  getKeyByKeyId(keyId, prov, alg) {
    const providerKeyFactory = this._providerKeyFactories.find(factory => factory.provider === prov && factory.algorithm === alg);

    if (!providerKeyFactory) {
      throw new Error('Provider key factory not found.');
    }

    return providerKeyFactory.getKeyByKeyId(keyId);
  }

  getOrCreateKey(name, prov, alg) {
    const providerKeyFactory = this._providerKeyFactories.find(factory => factory.provider === prov && factory.algorithm === alg);

    if (!providerKeyFactory) {
      throw new Error('Provider key factory not found.');
    }

    return providerKeyFactory.getOrCreateKey(name);
  }

}

exports.ProviderKeyService = ProviderKeyService;